import React, { useState } from "react";
import "./usuarios.css";
import "./ingresomk.css";

const Ingresomk = () => {
  // Estado del formulario principal
  const initialForm = {
    cliente: "",
    fecha: "",
    ubicacion: "",
    planta: "",
    unidadNegocio: "",
    nroRemito: "",
    fcGrupoProveedor: "",
    codigo: "",
    detalleProducto: "",
    nroFc: "",
    cantPorFc: "",
    lote: "",
    fechaElaboracion: "",
    fechaVencimiento: "",
    idInterno: "",
    tipoEmbalaje: "",
    pesoMedidas: "",
    nroPallet: "",
    unidadesPorPallet: "",
    recintoSenasa: "",
    ingresoPesa: "no", // "si" / "no"
    observacionesIngreso: "",
    condicion: "OK", // OK / ROTAS
  };

  const [form, setForm] = useState(initialForm);
  const [mantenerDatos, setMantenerDatos] = useState(true);
  const [replicarPor, setReplicarPor] = useState();
  const [pallets, setPallets] = useState([]);
  const [mostrarModal, setMostrarModal] = useState(false);

  // Maneja cambios en el formulario principal
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Maneja el checkbox de "mantener datos"
  const handleMantenerDatosChange = (e) => {
    setMantenerDatos(e.target.checked);
  };

  // Maneja el input "replicar ingreso por"
  const handleReplicarChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setReplicarPor(value);
  };

  // Agregar pallets al listado (botÃ³n "Continuar")
  const handleAgregarPallets = (e) => {
    e.preventDefault();

    const cantidad = replicarPor || 1;

    // Intento de numerar los pallets si nroPallet es numÃ©rico
    let basePalletNumber = parseInt(form.nroPallet, 10);
    const esBaseNumerica = !isNaN(basePalletNumber);

    const nuevosPallets = Array.from({ length: cantidad }, (_, index) => {
      const nroPalletCalculado = esBaseNumerica
        ? String(basePalletNumber + index)
        : form.nroPallet;

      return {
        cliente: form.cliente,
        fecha: form.fecha,
        ubicacion: form.ubicacion,
        planta: form.planta,
        unidadNegocio: form.unidadNegocio,
        nroRemito: form.nroRemito,

        fcGrupoProveedor: form.fcGrupoProveedor,
        codigo: form.codigo,
        detalleProducto: form.detalleProducto,
        nroFc: form.nroFc,
        cantPorFc: form.cantPorFc,
        lote: form.lote,
        fechaElaboracion: form.fechaElaboracion,
        fechaVencimiento: form.fechaVencimiento,
        idInterno: form.idInterno,
        tipoEmbalaje: form.tipoEmbalaje,
        pesoMedidas: form.pesoMedidas,
        nroPallet: nroPalletCalculado,
        unidadesPorPallet: form.unidadesPorPallet,
        recintoSenasa: form.recintoSenasa,
        ingresoPesa: form.ingresoPesa,
        observacionesIngreso: form.observacionesIngreso,
        condicion: form.condicion,

        motivoDanioIn: "",
        duplicarPallet: false,
        cuentaPosicion: true,
      };
    });

    setPallets((prev) => [...prev, ...nuevosPallets]);

    if (!mantenerDatos) {
      setForm(initialForm);
      setReplicarPor(1);
    }
  };

  // Maneja cambios en cada celda de la tabla de pallets
  const handlePalletChange = (index, field, value) => {
    setPallets((prev) =>
      prev.map((pallet, i) =>
        i === index
          ? {
              ...pallet,
              [field]: value,
            }
          : pallet
      )
    );
  };

  // Maneja cambios de checkbox en la tabla
  const handlePalletCheckbox = (index, field) => {
    setPallets((prev) =>
      prev.map((pallet, i) =>
        i === index
          ? {
              ...pallet,
              [field]: !pallet[field],
            }
          : pallet
      )
    );
  };

  // Eliminar una fila de pallets
  const handleEliminarPallet = (indexABorrar) => {
    setPallets((prev) => prev.filter((_, index) => index !== indexABorrar));
  };

  // cuando apreta enter en nro pallet, baja al nro pallet de la prox fila
  const handleEnterPallet = (e, index) => {
    if (e.key === "Enter") {
      const next = document.getElementById(`pallet-${index + 1}`);
      if (next) next.focus(); // existe -> enfoca siguiente
    }
  };

  // Resumen por lote para el modal
  const getResumenPorLote = () => {
    const resumen = {};

    pallets.forEach((p) => {
      const key = p.lote || "SIN LOTE";
      if (!resumen[key]) {
        resumen[key] = {
          lote: key,
          cantidadPallets: 0,
          totalUnidades: 0,
        };
      }
      resumen[key].cantidadPallets += 1;
      const unidades = parseFloat(p.unidadesPorPallet) || 0;
      resumen[key].totalUnidades += unidades;
    });

    return Object.values(resumen);
  };

  const totalPallets = pallets.length;
  const totalUnidades = pallets.reduce(
    (acc, p) => acc + (parseFloat(p.unidadesPorPallet) || 0),
    0
  );

  // llamar a la api para crear el ingreso
  const handleCompletarIngreso = () => {
    console.log(pallets);
    // await axios.post("/api/ingresos", { pallets });
  };

  const cerrarModal = () => {
    setMostrarModal(false);
  };

  // Opciones para los selects que se deben sacar segun el cliente(al crear el cliente se cargan estas cuestiones).
  const ubicaciones = ["DepÃ³sito A", "DepÃ³sito B", "CÃ¡mara FrÃ­a"];
  const plantas = ["Planta 1", "Planta 2"];
  const unidadesNegocio = ["Retail", "Industria", "ExportaciÃ³n"];

  /*
  const handleCompletarFormulario = () => {
    // await axios.get("/api/cliente/completarFormulario", { idCliente });
  };
  */
  return (
    <div className="users-wrap ingreso-wrap">
      <div className="users-header">
        <div className="title-stack">
          <h1>Ingreso</h1>
          <p className="subtitle">Carga rÃ¡pida de pallets con el estilo Binder</p>
        </div>
        <div className="toolbar" style={{ gap: 10 }}>
          {pallets.length > 0 && (
            <>
              <div className="pill ok">
                <span>Pallets</span>
                <strong className="mono">{totalPallets}</strong>
              </div>
              <div className="pill">
                <span>Unidades</span>
                <strong className="mono">{totalUnidades}</strong>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="panel">
        <form onSubmit={handleAgregarPallets} id="form-ingreso-mk">
          <div className="ingreso-section">
            <div className="section-header">
              <h2>Datos del ingreso</h2>
              <p className="subtitle">Cliente, fecha y destino</p>
            </div>
            <div className="mk-form-grid">
              <div className="field">
                <label>Cliente</label>
                <input
                  type="text"
                  name="cliente"
                  value={form.cliente}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>Fecha ingreso</label>
                <input
                  type="date"
                  name="fecha"
                  value={form.fecha}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>Ubicacion</label>
                <select
                  className="select"
                  name="ubicacion"
                  value={form.ubicacion}
                  onChange={handleFormChange}
                  style={{ width: "100%" }}
                >
                  <option value="">Seleccionar...</option>
                  {ubicaciones.map((u) => (
                    <option key={u} value={u}>
                      {u}
                    </option>
                  ))}
                </select>
              </div>
              <div className="field">
                <label>Planta</label>
                <select
                  className="select"
                  name="planta"
                  value={form.planta}
                  onChange={handleFormChange}
                  style={{ width: "100%" }}
                >
                  <option value="">Seleccionar...</option>
                  {plantas.map((p) => (
                    <option key={p} value={p}>
                      {p}
                    </option>
                  ))}
                </select>
              </div>
              <div className="field">
                <label>Unidad de negocio</label>
                <select
                  className="select"
                  name="unidadNegocio"
                  value={form.unidadNegocio}
                  onChange={handleFormChange}
                  style={{ width: "100%" }}
                >
                  <option value="">Seleccionar...</option>
                  {unidadesNegocio.map((u) => (
                    <option key={u} value={u}>
                      {u}
                    </option>
                  ))}
                </select>
              </div>
              <div className="field">
                <label>Nro. Remito</label>
                <input
                  type="text"
                  name="nroRemito"
                  value={form.nroRemito}
                  onChange={handleFormChange}
                />
              </div>
            </div>
          </div>

          <div className="ingreso-section">
            <div className="section-header">
              <h2>Producto y pallet</h2>
              <p className="subtitle">Datos a replicar en cada pallet</p>
            </div>
            <div className="mk-form-grid">
              <div className="field">
                <label>FC / Grupo / Proveedor</label>
                <input
                  type="text"
                  name="fcGrupoProveedor"
                  value={form.fcGrupoProveedor}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>Codigo</label>
                <input
                  type="text"
                  name="codigo"
                  value={form.codigo}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>Detalle de producto / Nro. FC</label>
                <input
                  type="text"
                  placeholder="Detalle de producto"
                  name="detalleProducto"
                  value={form.detalleProducto}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>Cant. x FC</label>
                <input
                  type="number"
                  name="cantPorFc"
                  value={form.cantPorFc}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>Lote</label>
                <input
                  type="text"
                  name="lote"
                  value={form.lote}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>Fecha elaboracion</label>
                <input
                  type="date"
                  name="fechaElaboracion"
                  value={form.fechaElaboracion}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>Fecha vencimiento</label>
                <input
                  type="date"
                  name="fechaVencimiento"
                  value={form.fechaVencimiento}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>ID</label>
                <input
                  type="text"
                  name="idInterno"
                  value={form.idInterno}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>Tipo embalaje</label>
                <input
                  type="text"
                  name="tipoEmbalaje"
                  value={form.tipoEmbalaje}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>Peso / Medidas</label>
                <input
                  type="text"
                  name="pesoMedidas"
                  value={form.pesoMedidas}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>Nro. pallet (base)</label>
                <input
                  type="text"
                  name="nroPallet"
                  value={form.nroPallet}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>Unidades por pallet</label>
                <input
                  type="number"
                  name="unidadesPorPallet"
                  min={1}
                  value={form.unidadesPorPallet}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>Recinto SENASA</label>
                <input
                  type="text"
                  name="recintoSenasa"
                  value={form.recintoSenasa}
                  onChange={handleFormChange}
                />
              </div>
              <div className="field">
                <label>Este ingreso pesa?</label>
                <select
                  className="select"
                  name="ingresoPesa"
                  value={form.ingresoPesa}
                  onChange={handleFormChange}
                  style={{ width: "100%" }}
                >
                  <option value="no">No</option>
                  <option value="si">Si</option>
                </select>
              </div>
              <div className="field">
                <label>Condicion</label>
                <select
                  className="select"
                  name="condicion"
                  value={form.condicion}
                  onChange={handleFormChange}
                  style={{ width: "100%" }}
                >
                  <option value="OK">OK</option>
                  <option value="ROTAS">Rotas</option>
                </select>
              </div>
              <div className="field" style={{ gridColumn: "1 / -1" }}>
                <label>Observaciones de ingreso</label>
                <input
                  type="text"
                  name="observacionesIngreso"
                  value={form.observacionesIngreso}
                  onChange={handleFormChange}
                />
              </div>
            </div>
          </div>

          <div className="ingreso-actions">
            <label className="checkbox ingreso-checkbox" htmlFor="mantenerDatos">
              <input
                className="form-check-input"
                type="checkbox"
                id="mantenerDatos"
                checked={mantenerDatos}
                onChange={handleMantenerDatosChange}
              />
              <span>Mantener datos</span>
            </label>
            <div className="field" style={{ maxWidth: 200 }}>
              <label>Replicar ingreso por</label>
              <input
                type="number"
                min={1}
                value={replicarPor || ""}
                onChange={handleReplicarChange}
              />
            </div>
            <div style={{ flex: 1 }} />
            <button type="submit" className="btn solid">
              Continuar (agregar pallets)
            </button>
          </div>
        </form>
      </div>

      {pallets.length > 0 && (
        <div className="panel">
          <div className="ingreso-panel-header">
            <div className="title-stack">
              <h2 style={{ margin: 0 }}>Pallets ingresados</h2>
              <p className="subtitle">EditÃ¡ o borra antes de confirmar</p>
            </div>
          </div>
          <div className="ingreso-table-wrapper">
            <table className="ingreso-table">
              <thead>
                <tr>
                  <th>FC/Grupo/Proveedor</th>
                  <th>Codigo</th>
                  <th>Detalle / Nro. FC</th>
                  <th>Cant x FC</th>
                  <th>Nro. lote</th>
                  <th>F. elaborac.</th>
                  <th>F. vencim.</th>
                  <th>ID</th>
                  <th>Tipo embalaje</th>
                  <th>Peso/medidas</th>
                  <th>Nro. pallet</th>
                  <th>Unid. x pallet</th>
                  <th>Condicion</th>
                  <th>Motivo daÃ±o in</th>
                  <th>Dup. pallet</th>
                  <th>Cuenta pos.</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {pallets.map((p, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="text"
                        value={p.fcGrupoProveedor}
                        onChange={(e) =>
                          handlePalletChange(
                            index,
                            "fcGrupoProveedor",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={p.codigo}
                        onChange={(e) =>
                          handlePalletChange(index, "codigo", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        placeholder="Detalle"
                        value={p.detalleProducto}
                        onChange={(e) =>
                          handlePalletChange(
                            index,
                            "detalleProducto",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={p.cantPorFc}
                        onChange={(e) =>
                          handlePalletChange(index, "cantPorFc", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={p.lote}
                        onChange={(e) =>
                          handlePalletChange(index, "lote", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="date"
                        value={p.fechaElaboracion}
                        onChange={(e) =>
                          handlePalletChange(
                            index,
                            "fechaElaboracion",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="date"
                        value={p.fechaVencimiento}
                        onChange={(e) =>
                          handlePalletChange(
                            index,
                            "fechaVencimiento",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={p.idInterno}
                        onChange={(e) =>
                          handlePalletChange(index, "idInterno", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={p.tipoEmbalaje}
                        onChange={(e) =>
                          handlePalletChange(
                            index,
                            "tipoEmbalaje",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={p.pesoMedidas}
                        onChange={(e) =>
                          handlePalletChange(index, "pesoMedidas", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        id={`pallet-${index}`}
                        value={p.nroPallet}
                        onChange={(e) =>
                          handlePalletChange(index, "nroPallet", e.target.value)
                        }
                        onKeyDown={(e) => handleEnterPallet(e, index)}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={p.unidadesPorPallet}
                        onChange={(e) =>
                          handlePalletChange(
                            index,
                            "unidadesPorPallet",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td>
                      <select
                        value={p.condicion}
                        onChange={(e) =>
                          handlePalletChange(index, "condicion", e.target.value)
                        }
                      >
                        <option value="OK">OK</option>
                        <option value="ROTAS">Rotas</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        value={p.motivoDanioIn}
                        onChange={(e) =>
                          handlePalletChange(
                            index,
                            "motivoDanioIn",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td className="text-center">
                      <input
                        type="checkbox"
                        checked={p.duplicarPallet}
                        onChange={() => handlePalletCheckbox(index, "duplicarPallet")}
                      />
                    </td>
                    <td className="text-center">
                      <input
                        type="checkbox"
                        checked={p.cuentaPosicion}
                        onChange={() => handlePalletCheckbox(index, "cuentaPosicion")}
                      />
                    </td>
                    <td className="text-center">
                      <button
                        type="button"
                        className="action-btn"
                        onClick={() => handleEliminarPallet(index)}
                        title="Eliminar pallet"
                      >
                        <i className="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="ingreso-summary">
            <div>
              <strong>Total pallets:</strong> {totalPallets}{" "}
              <span className="muted" style={{ marginLeft: 6 }}>
                Total unidades: {totalUnidades}
              </span>
            </div>
            <button
              type="button"
              className="btn solid"
              onClick={() => setMostrarModal(true)}
            >
              Finalizar
            </button>
          </div>
        </div>
      )}

      {mostrarModal && (
        <div className="modal-backdrop">
          <div className="modal panel">
            <div className="users-header" style={{ marginBottom: 10 }}>
              <div className="title-stack">
                <h3 style={{ margin: 0 }}>Resumen por lote</h3>
                <p className="subtitle">Pallets y unidades agrupados</p>
              </div>
              <button type="button" className="btn" onClick={cerrarModal}>
                Cerrar
              </button>
            </div>
            {pallets.length === 0 ? (
              <p className="muted">No hay pallets para mostrar.</p>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="resumen-table">
                    <thead>
                      <tr>
                        <th>Lote</th>
                        <th>Cantidad pallets</th>
                        <th>Total unidades</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getResumenPorLote().map((r) => (
                        <tr key={r.lote}>
                          <td>{r.lote}</td>
                          <td>{r.cantidadPallets}</td>
                          <td>{r.totalUnidades}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="ingreso-summary" style={{ marginTop: 10 }}>
                  <div>
                    <strong>Total pallets:</strong> {totalPallets}
                  </div>
                  <div>
                    <strong>Total unidades:</strong> {totalUnidades}
                  </div>
                </div>
              </>
            )}
            <div className="modal-actions">
              <button type="button" className="btn" onClick={cerrarModal}>
                Volver
              </button>
              <button className="btn solid" onClick={handleCompletarIngreso}>
                Confirmar y guardar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Ingresomk;

